import React, { Component } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import Modal from './Modal';

const newsletterImages = [
	{
		title: 'Featured Banner',
		imgURL: 'https://cdn.couponology.com/images/mediakit-newsletter-banner.png',
		alt: 'Featured Banner',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Featured Banner</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-center content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='newsletter-banner-img-sample' src='https://cdn.couponology.com/images/mediakit-newsletter-banner-placement.jpg' alt='Featured Banner' />
									<p className='img-properties'>
										A banner image containing text, offer codes, or logos. <br />
										<strong>Dimensions (pixels):</strong> 700 width x 385 height
										<br />
										<strong>Size:</strong> 60KB max
									</p>
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									The featured banner occupies prime real estate at the very top of Couponology's weekly newsletter and special holiday newsletters.
								</p>
								<p>
									The above-the-fold placement, and it's large size relative to the newsletter's other content ensures that your offer and your brand are seen by more than 1 million subscribers.
								</p>
								<p>
									Showcase your brand, delivered straight to your customers' inbox every week, with a featured newsletter banner.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Top Weekly Deals',
		imgURL: 'https://cdn.couponology.com/images/mediakit-newsletter-top-deals.png',
		alt: 'Top Weekly Deals',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Top Weekly Deals</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-center content'>
								<div style={{display: 'inline-block'}} className='text-right'>
									<img className='cat-img-sample' src='https://cdn.couponology.com/images/mediakit-newsletter-top-weekly-deals-placement.jpg' alt='Top Weekly Deals' />
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Your brand, your logo and your best deal of the week. That's what is offered in our top 12 weekly deals. With 12 placement opportunities, across 4 rows, the top weekly deals serve to achieve maximum revenue growth by showcasing your best offers, front-and-center, for our newsletter subscribers.
								</p>
								<p>
									Bring more attention to your established brand and feature your best deal, seen by more than 1 million subscribers, delivered straight to their inbox every week.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Featured Deals',
		imgURL: 'https://cdn.couponology.com/images/mediakit-newsletter-featured-deals.png',
		alt: 'Featured Deals',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Featured Deals</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-right content'>
								<div className='row'>
									<div style={{display: 'inline-block'}} className='col-sm-6 col-md-12 col-lg-12 text-left'>
										<img className='newsletter-featured-img-sample' src='https://cdn.couponology.com/images/mediakit-newsletter-left-featured-placement.jpg' alt='Featured Left Deal' />
										<p className='img-properties'>
											A lifestyle image with no text, offer codes, or logos. <br />
											<strong>Dimensions (pixels):</strong> 320 width x 465 height
											<br />
											<strong>Size:</strong> 50KB max
										</p>
									</div>
									<div style={{display: 'inline-block', marginTop: '10px'}} className='col-sm-6 col-md-12 col-lg-12 text-left'>
										<img className='newsletter-featured-img-sample' src='https://cdn.couponology.com/images/mediakit-newsletter-right-featured-placement.jpg' alt='Right Featured Deal' />
										<p className='img-properties'>
											A lifestyle image with no text, offer codes, or logos. <br />
											<strong>Dimensions (pixels):</strong> 320 width x 216 height
											<br />
											<strong>Size:</strong> 15KB max
										</p>
									</div>
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									When showcasing your best offer requires special attention, that's what the featured deals are for. Featured deals draws eyes and captures the attention of over 1 million newsletter subscribers.
								</p>
								<p>
									Engage your audience with captivating lifestyle images. The featured deals section offers 3 placement opportunities in 2 distinct sizes to bring your best offer into focus.
								</p>
								<p>
									Convert clicks into purchases and increase your customer base and your revenue with a featured deal placement.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: 'Featured Stores',
		imgURL: 'https://cdn.couponology.com/images/mediakit-newsletter-spotlight-stores.png',
		alt: 'Featured Stores',
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Featured Spotlight Stores</h3>
						<div className='row'>
							<div className='col-md-12 content'>
								<div style={{display: 'inline-block', marginTop: '10px'}} className='text-left'>
									<img className='newsletter-spotlight-img-sample' src='https://cdn.couponology.com/images/mediakit-spotlight-stores.png' alt='spotlight stores' />
								</div>
							</div>
							<div className='col-md-12 content'>
								<h4>Product Description:</h4>
								<p>
									No matter where you are on Couponology, your company logo will follow. This also includes automatic placement in our weekly and holiday newsletters.
								</p>
								<p>
									Our spotlight stores placement offers sitewide and newsletter placement of your company logo ensuring quick one-click access to your branded store page.
								</p>
							</div>
						</div>
					</SimpleBar>
	}
];

export default class Newsletter extends Component {
	constructor(props) {
		super(props);
		this.state = { isModalOpen: false, modalContent: '' };
	}
	
	  toggleModal = () => {
			this.setState({
				isModalOpen: !this.state.isModalOpen
			});
		}
		
		addModalContent = (modal_content) => {
			this.setState({
				modalContent: modal_content
			});
		}

	render() {
		return(
			<div className='row min-height-400 border component' id='newsletter'>
				<div className='col-md-12 text-center'>
					<h2 className='section-heading'>28 Newsletter Opportunities</h2>
					<ul className='sub-heading-list'>
						<li>
							<span>40 Unique Categories</span>
						</li>
						<li>
							<span className='glyphicon glyphicon-stop' aria-hidden='true'></span>
							<span>330x480 Top of Page Banners</span>
						</li>
						<li>
							<span className='glyphicon glyphicon-stop' aria-hidden='true'></span>
							<span>Captivating Lifestyle Images</span>
						</li>
					</ul>
				</div>
				{newsletterImages.map((newsletterImage, key) => 
					<div className='col-md-3 text-center' key={key}>
						<h3>{newsletterImage.title}</h3>
						<div className='img-container'>
							<img src={newsletterImage.imgURL} alt={newsletterImage.alt} />
							<div className='overlay' />
							<div className='btn-container'>
								<button className='btn-1' onClick={() => {this.toggleModal(); this.addModalContent(newsletterImage.modalContent);}}>See details</button>
							</div>
						</div>
					</div>
				)}

				{this.state.isModalOpen ? 
					<Modal
						text={this.state.modalContent}
						open={this.state.isModalOpen}
						onClose={this.toggleModal.bind(this)}
					/> : ''}
			</div>
		);
	}
}